module.exports = __webpack_public_path__ + "static/popcorntest-31dc2d6c8c9ac3ddfe5a52affc04d698.svg";